import routerOptions0 from "/build/incl/node_modules/.pnpm/nuxt@3.21.11_@types+node@24.19.2_@vue+compiler-sfc@3.5.44_esbuild@0.25.1_eslint@8.55.0__9b8d368a841e06098d7f405f471e9499/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}